import styled from 'styled-components'
import { theme } from '@superhi/design'
import svgToTinyDataUri from 'mini-svg-data-uri'

const horizontalLine = svgToTinyDataUri(
  `<svg width="1" height="48" viewBox="0 0 1 48" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="0.5" x2="1" y2="0.5" stroke="${theme.colors.PALE_BLUE_50}"></line></svg>`,
)

export const Wrapper = styled.div`
  padding: 24px;
  border-radius: 10px;
  position: relative;
  max-width: 560px;

  background-color: ${theme.colors.YELLOW_20};
  background-image: url("${horizontalLine}");
  background-repeat: repeat;
  background-position: 0 24px;

  @media ${theme.breakpoints.large} {
    padding: 40px;
    max-width: none;
  }

  &:before {
    content: '';
    position: absolute;
    left: 24px;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: ${theme.colors.PINK_30};
  }

  &:not(:first-child) {
    margin-top: 40px;
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`
